export default {
  getConfig:(state)=>{
    return state.config
  },
  getHubConnection:(state)=>{
    return state.getHubConnection
  },

  getUserRole:(state)=>{
    return state.userRole
  },
  getUserAccounts:(state)=>{
    return state.userAccounts
  },

  getSnackSettings: (state)=>{
    return state.snackSettings
  },

  getSnackTrigger: (state)=>{
    return state.snackSettings.trigger
  },

  getInvestmentModalTrigger:(state)=>{
    return state.investmentModalTrigger
  },
  getInvestmentData:(state)=>{
    return state.investmentData
  },

  getFundingCampaigns:(state)=>{
    return state.fundingCampaigns
  },

  getModals:(state)=>{
    return state.modals
  }

}